import React from 'react';
import { Phone, Mail, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-amber-900 to-amber-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/images/branding/logo.png" 
                alt="Marina Homes Logo" 
                className="h-12 w-auto bg-white rounded-lg p-1"
              />
              <h3 className="text-2xl font-bold">{businessInfo.name}</h3>
            </div>
            <p className="text-amber-100">
              Your home away from home. Experience luxury, comfort, and warmth in our beautifully designed serviced apartments.
            </p>
            {/* Social Links */}
            <div className="mt-4">
              <a 
                href="https://www.instagram.com/marinahomestz"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-4 py-2 rounded-lg hover:from-pink-600 hover:to-purple-600 transition-all"
              >
                <Instagram size={20} />
                <span>Follow us on Instagram</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100 hover:text-white transition-colors"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('reviews').scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100 hover:text-white transition-colors"
                >
                  Reviews
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="text-amber-100 hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a 
                href={`tel:${businessInfo.phone}`}
                className="flex items-center space-x-3 text-amber-100 hover:text-white transition-colors"
              >
                <Phone size={20} />
                <span>{businessInfo.phone}</span>
              </a>
              <a 
                href={`mailto:${businessInfo.email}`}
                className="flex items-center space-x-3 text-amber-100 hover:text-white transition-colors"
              >
                <Mail size={20} />
                <span className="break-all">{businessInfo.email}</span>
              </a>
              <a 
                href="https://www.instagram.com/marinahomestz"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-3 text-pink-300 hover:text-pink-200 transition-colors"
              >
                <Instagram size={20} />
                <span>@marinahomestz</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-amber-700 pt-8 text-center">
          <p className="text-amber-100">
            &copy; {new Date().getFullYear()} {businessInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
